import React from 'react';
import PropTypes from 'prop-types';
import ModalRoot, { Modal, ModalBody, ModalHeader } from '../../components/Modal';
import CardConnectFinancialDetailsView from '../../screens/Card/CardConnectFinancialDetailsView';

const CardConnectFinancialDetailsModal = ({ hide }) => (
  <ModalRoot>
    <Modal contentStyle={{ maxHeight: '33rem' }}>
      <ModalHeader>
        <i
          onClick={hide}
          onKeyDown={hide}
          role="button"
          className="close-btn cursor-pointer icon icon-close-other text-shadow"
          tabIndex={-1}
          aria-label="Close"
        />
      </ModalHeader>
      <ModalBody>
        <CardConnectFinancialDetailsView />
      </ModalBody>
    </Modal>
  </ModalRoot>
);

CardConnectFinancialDetailsModal.propTypes = {
  hide: PropTypes.func.isRequired,
};

export default CardConnectFinancialDetailsModal;
